import { Pagination } from './types';

export const transformPaginationToSearchParams = (pagination: Pagination) => {
  const paginationParams = [
    { key: 'page', value: pagination.page.toString() },
    { key: 'pageSize', value: pagination.pageSize.toString() }
  ];

  return paginationParams;
};
